import { ReceptionTypeItem } from ".";

// 入力部署
export class ReceptionInputSection extends ReceptionTypeItem {
  constructor(id: number, name: string, isDisable: boolean) {
    super(id, name, isDisable);
  }

  static areEqual(source: ReceptionInputSection, dest: ReceptionInputSection): boolean {
    return (source === dest)
      || (source && dest && (source.id === dest.id));
  }
}
